export enum RolesDashboardType {
    all,
    poi,
    onlyPresence,
    withoutPresence,
    inOut,
    inOutGender,
    none,
    roi,
    storeWindow,
    storeFront
  }